import { RGBColor } from "react-color";

export function getComplementaryColor(color: RGBColor, alpha: number = .2): RGBColor {
  return {
    r: 255 - color.r,
    g: 255 - color.g,
    b: 255 - color.b,
    a: alpha
  };
}

export function getRandomHexColor(): string {
  return "#" + Math.floor(Math.random() * 16777215).toString(16);
}